/* Ambient Wardrobe learning from meaningful product-page engagement. */
(function () {
  'use strict';

  var ENGAGED_VIEW_MS = 8000;
  var SESSION_KEY = 'prewornProductBrandLearningV1';
  var section = document.querySelector('[data-pw-product-brand-learning]');
  if (!section) return;

  var brand = String(section.getAttribute('data-pw-product-brand') || '')
    .replace(/\s+/g, ' ').trim().slice(0, 100);
  var productId = String(section.getAttribute('data-pw-product-id') || '').trim();
  var contextCollection = String(
    section.getAttribute('data-pw-product-context-collection') || ''
  ).toLowerCase().trim();
  var productCollections = String(
    section.getAttribute('data-pw-product-collections') || ''
  ).split(',').map(function (value) {
    return String(value || '').toLowerCase().trim();
  }).filter(Boolean);

  if (!brand || !productId || !productCollections.length) return;
  if (contextCollection && productCollections.indexOf(contextCollection) === -1) {
    productCollections.unshift(contextCollection);
  } else if (contextCollection) {
    productCollections.splice(productCollections.indexOf(contextCollection), 1);
    productCollections.unshift(contextCollection);
  }

  var finished = false;
  var learning = false;
  var timer = 0;
  var visibleSince = 0;
  var visibleTime = 0;

  function readSession() {
    try {
      var parsed = JSON.parse(window.sessionStorage.getItem(SESSION_KEY) || '{}');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (error) {
      return {};
    }
  }

  function writeSession(value) {
    try { window.sessionStorage.setItem(SESSION_KEY, JSON.stringify(value)); }
    catch (error) { /* Learning must never interrupt a product page. */ }
  }

  function emit(name, properties) {
    var detail = properties || {};
    window.dispatchEvent(new CustomEvent('preworn:' + name, { detail: detail }));
    window.dispatchEvent(new CustomEvent('preworn:analytics', {
      detail: { event: name, properties: detail }
    }));
  }

  function hasProfileSelections(profile) {
    if (!profile || !Array.isArray(profile.categories) || !profile.categories.length) {
      return false;
    }
    var sizes = profile.sizes || {};
    return profile.categories.length > 0 || ['top', 'bottom', 'dress', 'shoe'].some(function (type) {
      return Array.isArray(sizes[type]) && sizes[type].length;
    });
  }

  function matchingProfile(api) {
    var profiles = [];
    var seen = {};
    function include(profile) {
      if (!hasProfileSelections(profile)) return;
      var key = profile.id ? 'id:' + profile.id :
        'audience:' + String(profile.audience || '') + ':' + String(profile.name || '');
      if (seen[key]) return;
      seen[key] = true;
      profiles.push(profile);
    }

    if (typeof api.getWardrobe === 'function') include(api.getWardrobe());
    if (typeof api.getWardrobeForAudience === 'function') {
      ['woman', 'man', 'girl', 'boy', 'baby'].forEach(function (audience) {
        include(api.getWardrobeForAudience(audience));
      });
    }

    for (var collectionIndex = 0; collectionIndex < productCollections.length; collectionIndex++) {
      var categoryKey = productCollections[collectionIndex];
      for (var profileIndex = 0; profileIndex < profiles.length; profileIndex++) {
        var profile = profiles[profileIndex];
        if (profile.categories.indexOf(categoryKey) !== -1) {
          return { profile: profile, categoryKey: categoryKey };
        }
      }
    }
    return null;
  }

  function sessionMarker(match) {
    var profile = match.profile;
    return [
      productId,
      profile.id || profile.audience || 'profile',
      match.categoryKey,
      brand.toLowerCase()
    ].join(':');
  }

  function learnBrand(source) {
    if (finished || learning) return;
    var api = window.PrewornWardrobe;
    if (!api || typeof api.ready !== 'function' ||
        typeof api.addCategoryBrand !== 'function') return;
    learning = true;
    Promise.resolve(api.ready()).then(function () {
      var match = matchingProfile(api);
      if (!match) return null;
      var marker = sessionMarker(match);
      var session = readSession();
      if (session[marker]) {
        finished = true;
        return null;
      }
      var preference = match.profile.categoryPreferences &&
        match.profile.categoryPreferences[match.categoryKey];
      var brands = preference && Array.isArray(preference.brands)
        ? preference.brands : [];
      if (brands.some(function (value) {
        return String(value || '').toLowerCase() === brand.toLowerCase();
      })) {
        session[marker] = Date.now();
        writeSession(session);
        finished = true;
        return null;
      }
      return api.addCategoryBrand(
        match.categoryKey,
        brand,
        match.profile.audience,
        { activate: false, source: source }
      ).then(function () {
        session[marker] = Date.now();
        writeSession(session);
        finished = true;
        emit('brand_inferred_from_product_view', {
          brand: brand,
          category: match.categoryKey,
          audience: match.profile.audience,
          source: source
        });
      });
    }).catch(function () {
      // This is optional ambient learning; product browsing must remain intact.
    }).then(function () {
      learning = false;
    });
  }

  function accrueVisibleTime() {
    if (!visibleSince) return;
    visibleTime += Math.max(0, Date.now() - visibleSince);
    visibleSince = 0;
  }

  function scheduleEngagedView() {
    if (finished || timer || document.visibilityState === 'hidden') return;
    visibleSince = Date.now();
    timer = window.setTimeout(function () {
      timer = 0;
      accrueVisibleTime();
      if (visibleTime >= ENGAGED_VIEW_MS) learnBrand('engaged_product_view');
      else scheduleEngagedView();
    }, Math.max(250, ENGAGED_VIEW_MS - visibleTime));
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      if (timer) window.clearTimeout(timer);
      timer = 0;
      accrueVisibleTime();
    } else {
      scheduleEngagedView();
    }
  });

  section.addEventListener('click', function (event) {
    var target = event.target && event.target.closest
      ? event.target.closest('button[name="add"], [data-pw-offer-proxy]') : null;
    if (target) learnBrand('product_action');
  });

  scheduleEngagedView();
})();
